module.exports = __webpack_public_path__ + "static/media/fingerprint.96c9e0bb.svg";